import {PriceList}    from "../../../shared-gen/Model/PriceLists/PriceList";
import {getDefaultID} from "../../core";
import { EntityType } from "../../../shared-gen/Model/Utils/EntityType";

export class PriceListFun {

	static createNew(providerID: string): PriceList {
		return {
			Type: EntityType.PriceList,
			ID: getDefaultID(),
			Hash: '',
			Name: '',
			Condition: null,
			Prices: [],
			ProviderID: providerID
		};
	}

}
